import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";

import Contributor from "../contributor/index";
import ResponsiveImageWithFallback from "../responsive-image-with-fallback";
import { getStoryData, generateImageSources, checkAppSlug } from "../../utils/utils";
import { PremiumBadge } from "../../atoms/premium-badge";
import { isPremium } from "../../../../isomorphic/data/story";

import styles from "./styles.m.css";

export const StoryCardML8x5DP7x5HeadlineOverlay = ({ story, className = "", cardWithImageZoom = true }) => {
  const storyData = getStoryData(story);

  if (!(storyData.headline && story.url)) {
    return null;
  }

  const contributorName = get(story, ["authors", 0, "name"], null);
  const contributorRole = get(story, ["authors", 0, "contributor-role", "name"], "");
  const externalLink = get(story, ["metadata", "reference-url"]);
  const checkSlug = checkAppSlug();
  let SourceLink = "";
  if (checkSlug) {
    SourceLink = externalLink || story.url;
  }

  return (
    <Link
      aria-label={`${"Read full story: "} ${storyData.headline}`}
      href={externalLink || story.url}
      externalLink={SourceLink || externalLink}
      className={`${styles["base"]} ${className} ${cardWithImageZoom ? "card-with-image-zoom" : ""}`}
    >
      <div className={styles["image-container"]}>
        <ResponsiveImageWithFallback
          className={styles["image-wrapper"]}
          slug={storyData.imageS3Key}
          metadata={storyData.imageMetadata}
          alt={storyData.imageCaption}
          imgParams={{ auto: ["format", "compress"] }}
          sources={generateImageSources(
            {
              aspectRatio: [8, 5],
              screenWidthCoverage: 0.5
            },
            {
              aspectRatio: [7, 5],
              screenWidthCoverage: 0.4
            }
          )}
        />
      </div>
      <div className={styles["text-wrapper"]}>
        {contributorName && (
          <Contributor name={contributorName} type={contributorRole} className={styles["contributor"]} />
        )}
        <h3 className={`${styles["headline"]}`}>{storyData.headline}</h3>
        <PremiumBadge isPremium={isPremium(story)} positionClass="topLeft" />
      </div>
    </Link>
  );
};

StoryCardML8x5DP7x5HeadlineOverlay.propTypes = {
  className: PropTypes.string,
  cardWithImageZoom: PropTypes.bool,
  story: PropTypes.shape({
    id: PropTypes.string,
    authors: PropTypes.arrayOf(
      PropTypes.shape({
        "contributor-role": PropTypes.shape({
          name: PropTypes.string
        }),
        name: PropTypes.string
      })
    ),
    headline: PropTypes.string.isRequired,
    metadata: PropTypes.shape({
      "reference-url": PropTypes.string
    }),
    alternative: PropTypes.shape({
      home: PropTypes.shape({
        default: PropTypes.shape({
          headline: PropTypes.string
        })
      })
    }),
    slug: PropTypes.string.isRequired,
    "hero-image-metadata": PropTypes.shape({
      height: PropTypes.number,
      width: PropTypes.number,
      "aspect-ratio": PropTypes.arrayOf(PropTypes.number)
    }),
    "hero-image-s3-key": PropTypes.string,
    "hero-image-caption": PropTypes.string
  })
};

export default StoryCardML8x5DP7x5HeadlineOverlay;
